import React from "react";

function PhanquyenSection() {
  return <div>Tính năng đang phát triển</div>;
}

export default PhanquyenSection;
